import { Link } from 'react-router-dom';

const footerCategories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-excel-2-line text-white text-sm"></i>
              </div>
              <span className="font-heading text-lg text-foreground-950">
                Vigorbuy Spreadsheet
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your trusted resource for Vigorbuy Spreadsheet guides, reviews, templates, and expert insights. Helping businesses make smarter spreadsheet decisions since 2024.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  Shopping Guide
                </Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-templates" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  Templates
                </Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-comparisons" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  Comparisons
                </Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-security" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  Security
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  Vigorbuy Spreadsheet Official
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">Shop Categories</h4>
            <ul className="space-y-2.5">
              {footerCategories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">More Categories</h4>
            <ul className="space-y-2.5">
              {footerCategories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet. All rights reserved. This is an independent resource website.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
              Official Store
            </a>
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
              Home
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}